import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowElbowDownLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	viewBox: "0 0 256 256",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M200,32V176a8,8,0,0,1-8,8H67.31l34.35,34.34a8,8,0,0,1-11.32,11.32l-48-48a8,8,0,0,1,0-11.32l48-48a8,8,0,0,1,11.32,11.32L67.31,168H184V32a8,8,0,0,1,16,0Z" })
});
export default SvgArrowElbowDownLeft;
